<ng-content select="td-wb-sticky-panel-bottom-content" />
<td-wb-sticky-observer [offset]="1"
                       [bottom]="true"
                       (stateChange)="stickyStateChange($event)" />
